import * as React from "react";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import NProgress from "nprogress";
// Mui
import MuiDrawer from "@mui/material/Drawer";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import CssBaseline from "@mui/material/CssBaseline";
import {
  Box,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
// Icons
import PaymentIcon from "@mui/icons-material/Payment";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AssignmentIcon from "@mui/icons-material/Assignment";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import AdjustIcon from "@mui/icons-material/Adjust";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import RuleIcon from "@mui/icons-material/Rule";
import EngineeringIcon from "@mui/icons-material/Engineering";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BadgeIcon from "@mui/icons-material/Badge";
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import BuildIcon from '@mui/icons-material/Build';
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SavingsIcon from "@mui/icons-material/Savings";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import EventNoteIcon from "@mui/icons-material/EventNote";
// Customimport 
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SummarizeIcon from '@mui/icons-material/Summarize';

import AdminMenuBar from "./AdminMenuBar";
import { FullLogo, Logo } from "../../../../svg/Logo";
import SettingsMenu from "./SettingsMenu";
import FinanceMenu from "./FinanceMenu";
import AtsMenu from "./AtsMenu";
import AppBar from "./AppBar";
import MobileMenu from "./MobileMenu";
import * as ActionTypes from "../../../../store/Menu/ActionTypes";
import {
  checkPayrollAccess,
  getDomain,
  getUserData,
  isAdminOwner,
} from "../../Base/helper/baseFunctions";
import "../css/style.css";
import Footer from "../../Base/views/Footer";
import { useEffect } from "react";
import WorkIcon from "@mui/icons-material/Work";
import PersonIcon from "@mui/icons-material/Person";
import PowerUserWarningPopup from "../../Ancillary/PowerUserAccess/views/PowerUserWarningPopup";
import {
  AddMenuHeadingAction,
  setSelectedMenuPathAction,
} from "../../../../store/Menu/Action";
import ProposeCandidateConfirmation from "../../Base/views/ProposeCandidateConfirmation";
import {
  AddAtsJobPostFillterAction,
  AtsJobPostModeAction,
} from "../../../../store/ATS/JobPost/Action";
import Popup from "../../Base/views/Popup";
import PlanExpired from "./PlanExpired";
import LmsMenu from "./LmsMenu";
import EmployeeMenu from "./EmployeeMenu";
import { useLocation } from "react-router-dom";
import MyFinanceMenu from "./MyFinanceMenu";
import TuneIcon from '@mui/icons-material/Tune';
import VisitorsManagementMenu from "./VisitorsManagementMenu";
import ExpenseManagementMenu from "./ExpenseManagementMenu";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import AssessmentIcon from '@mui/icons-material/Assessment';
import ECMSMenu from "./ECMSMenu";
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import ReduceCapacityIcon from '@mui/icons-material/ReduceCapacity';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import CanteenManagementMenu from "./CanteenManagementMenu";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import StorefrontIcon from '@mui/icons-material/Storefront';
import FlatwareIcon from '@mui/icons-material/Flatware';
import AuthorizationMenu from "./AuthorizationMenu";

const drawerWidth = 245;
const openedMixin = (theme) => ({
  width: drawerWidth,
  zIndex: theme.zIndex.drawer,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => !["open", "fixMenuVal"].includes(prop),
})(({ theme, open, fixMenuVal }) => ({
  width: drawerWidth,
  flexShrink: `${fixMenuVal ? 0 : "unset"}`,
  BackdropProps: { invisible: true },
  whiteSpace: "nowrap",
  zIndex: open ? theme.zIndex.drawer + 1 : "auto",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MenuLandingPage({ children }) {
  const theme = useTheme();
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [selectedMenu, setSelectedMenu] = useState();
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  //const [collapse, setCollapse] = useState(false);
  const [show, setShow] = useState(false);
  const [popupContent, setPopupContent] = useState("");
  const [planExpired, setPlanExpired] = useState(false);
  const [planRemain, setPlanRemain] = useState(false);
  const dispatch = useDispatch();
  const { open, fixedMenu, isMobile } = useSelector(
    (state) => state?.MenuReducer
  );
  const { access } = useSelector((state) => state.UserAccessReducer);
  const { userInfo, userInfoData } = useSelector(
    (state) => state?.SignInReducer
  );
  const {
    atsCollapse,
    atsManageCollapse,
    atsReportCollapse,
    lmsCollapse,
    EmployeeCollapse,
    financeCollapse,
    myfinanceCollapse,
    settingCollapse,
    visitorsCollapse,
    canteenCollapse,
    expenseCollapse
  } = useSelector((state) => state?.MenuReducer);
  const { atsModuleData } = useSelector(
    (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
  );

  const { configurestatusData } = useSelector(
    (state) => state?.AncillaryReducer?.ConfigureReducer
  );

  const { Statusdata } = useSelector(
    (state) => state?.MeeplAdminReducer?.WorkspaceReducer
  );
  const RequestStatus = Statusdata?.[0]?.fn_get_request_user_status?.status;
  const userData = getUserData();
  const isGroupOrgFlowTrue = userData?.grouporg_flow === true;
  const location = useLocation();
  const [hoverLock, setHoverLock] = useState(false);
  
  useEffect(() => {
    const routeToHeading = {
      '/home': 'Home',
      '/employee': "It's Me",
      '/lms/manage-dashboard': 'LMS Dashboard',
      '/lms/manage-timesheet': 'My Timesheet',
      '/lms/manage-team': 'Team',
      '/lms/team-time': 'Team Time',
      '/time-bulk-upload': 'Time Bulk Upload',
      '/holidays': 'Holidays',
      '/tax-declaration': 'Tax Declaration',
      '/employee-report': 'Reports ',
      '/myemployee': 'Employee',
      '/authorization-management': 'Authorization Management',
      '/employee-bulk-upload': 'Employee Bulk Upload',
      '/myemployee-assets-management': 'Asset Management',
      '/payrollconfig-employee': 'PayConfig',
      // '/employee-time': 'Employee Time',
      '/payroll-dashboard': 'PayInsights',
      '/payroll-wage-entry': 'PayEntry',
      '/payroll-payecms': 'PayECMS',
      '/team-tax-declaration': 'Team Tax Approval',
      '/team-tax-adminview': 'Team Tax Approval',
      '/myemployee-reports': 'PayReports',
      '/payroll': 'Payroll Home',
      '/finance-report': 'Finance Reports',
      '/configure-setting': 'Quick Setup',
      '/settings': 'General',
      '/finance-settings': 'Finance',
      '/role-access': 'Roles & Access',
      '/ats/ats-settings/': 'ATS',
      '/ats/dashboard': 'ATS Dashboard',
      '/ats/tasks/': 'Tasks',
      '/ats/hiring-requests': 'Hiring Request',
      '/ats/manage-job': 'Job Dashboard',
      '/ats/manage-candidate': 'Candidate',
      '/ats/manage-user': 'Add Users',
      '/ats/manage-company': 'Add Client',
      '/ats/manage-group-company': 'Add Group Organisation',
      '/ats/manage-consultancy': 'Add Hiring Partner',
      '/ats/manage-reports/': 'Dashboard',
      '/ats/reports/': 'Operational Reports',
      '/ats/revenue/': 'Revenue',
      '/ats/agreements': 'Agreements',
      "/ats/invoice": "Invoice",
      "/onboarding": "Employee Onboarding",
      '/subscribe': 'Subscription',
      '/visitors-dashboard': 'Dashboard ', // extraspace is kept for differenciating
      '/visitors-record': 'Report',
      '/visitors-management-region': 'Visitor Entry',
      '/visitors-pre-registration': 'Pre-registration',
      '/visitors-management/settings': 'Visitor Management',
      '/expense-management/my-expenses': 'My Expenses',
      '/expense-management/team-expenses': 'Team Expenses',
      '/expense-management/settings': 'Expense Management',
      '/performance-management': 'Achievement Orchestrator',
      '/settings/performance-management': 'Performance Management',
      '/payroll-management': 'PayRun',
      '/exit-management/my-ecms': 'My ECMS',
      '/exit-management/admin-view': 'Admin View',
      '/exit-management/manager-view': 'Manager View',
      '/exit-management': "Exit Management",
      "/canteen-management-tokenconfig": "Token Config",
      "/canteen-management-region": "Canteen Entry",
      "/canteen-management/settings": "Canteen Management"
    };
    const currentPath = location.pathname;
    const paths = {
      "/ats/suggest-candidate": "Job Dashboard",
    };
    let currentHeading;
    const matchedPath = Object.keys(paths).find(path =>
      currentPath.startsWith(path)
    );
    if (matchedPath) {
      currentHeading = paths[matchedPath];
    } else {
      currentHeading = routeToHeading[currentPath];
    }
    if (currentHeading) {
      sessionStorage.setItem("selectedMenu", currentHeading);
      dispatch(AddMenuHeadingAction({ heading: currentHeading }));

      // Immediately clear Job Dashboard filters if we navigate away from it
      if (currentHeading !== "Job Dashboard") {
        dispatch(AddAtsJobPostFillterAction({}));
      }
      // Highlight the Active Tab securely
      setSelectedMenu(currentHeading === "LMS Dashboard" ? "Dashboard" : currentHeading);
    }

    // Automatically close the Mobile Sidebar after a link is clicked
    if (isMobile) {
      setOpenMobileMenu(false);
      dispatch({ type: ActionTypes.CLOSE_MENU });
    }

    // Evaluate Workspace Expiry on every URL change
    if (userInfoData) {
      checkWorkspaceExpiry();
    }
    // eslint-disable-next-line
  }, [location, dispatch, userInfo, Statusdata]);

  // Workspace Expiry Evaluator
  const checkWorkspaceExpiry = () => {
    if (parseInt(userInfoData?.expiry_days) === 0) {
      const inputDate = userInfoData?.expiry_date;
      const formattedDate = new Date(inputDate).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
      setShow(true);
      if (userInfoData?.post_req_count === "1") {
        setPopupContent(
          "Thanks for your patience, your request is with us. We will keep you updated."
        );
      } else {
        setPopupContent(
          `${userInfoData?.domainname} Workspace Expired on ${formattedDate}`
        );
      }
      setPlanExpired(true);
    }
    if (RequestStatus === false) {
      if (userInfoData?.pre_req_count === "0") {
        if (
          parseInt(userInfoData?.expiry_days) > 0 &&
          parseInt(userInfoData?.expiry_days) <=
          parseInt(userInfoData?.cut_off_no_of_days)
        ) {
          setShow(true);
          setPopupContent(
            `${userInfoData?.domainname} Workspace will Expire in ${userInfoData?.expiry_days} days`
          );
          setPlanRemain(true);
        }
      }
    }
  };
  // based on window size auto open mobile menu
  useEffect(() => {
    NProgress.configure({ showSpinner: false });
    
    const handleWindowResize = () => {
      if (window.innerWidth > 850) {
        dispatch({ type: "MOBILE_MENU", payload: false });
      } else {
        dispatch({ type: "MOBILE_MENU", payload: true });
      }
    };
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // when main menu collpases all the sub menu also collapses
  useEffect(() => {
    if (!open && !isMobile) {
      if (atsCollapse) dispatch({ type: ActionTypes.ATS_COLLAPSE_MENU });
      if (atsManageCollapse) dispatch({ type: ActionTypes.ATS_COLLAPSE_SUB_MENU });
      if (atsReportCollapse) dispatch({ type: ActionTypes.ATS_REPORT_COLLAPSE_MENU });
      if (lmsCollapse) dispatch({ type: ActionTypes.LMS_COLLAPSE_MENU });
      if (EmployeeCollapse) dispatch({ type: ActionTypes.EMPLOYEE_COLLAPSE_MENU });
      if (financeCollapse) dispatch({ type: ActionTypes.FINACNE_COLLAPSE_MENU });
      if (myfinanceCollapse) dispatch({ type: ActionTypes.MY_FINACNE_COLLAPSE_MENU });
      if (settingCollapse) dispatch({ type: ActionTypes.SETTINGS_COLLAPSE_MENU });
      if (visitorsCollapse) dispatch({ type: ActionTypes.VISITORS_MANAGEMENT_COLLAPSE_MENU });
      if (canteenCollapse) dispatch({ type: ActionTypes.CANTEEN_MANAGEMENT_COLLAPSE_MENU });
      if (expenseCollapse) dispatch({ type: ActionTypes.EXPENSE_MANAGEMENT_COLLAPSE_MENU });
    }
  }, [open, isMobile, atsCollapse, atsManageCollapse, atsReportCollapse, lmsCollapse, EmployeeCollapse, financeCollapse, myfinanceCollapse, settingCollapse, visitorsCollapse, expenseCollapse, dispatch, canteenCollapse]);

  const handleMenuClick = (menu, route) => {
    if (sessionStorage.getItem("selectedMenu") === "Job Dashboard") {
      dispatch(AtsJobPostModeAction({ job_mode: "grid" }));
    }
    if (menu === "Quick Setup") {
      sessionStorage.setItem("selectedMenu", "");
      dispatch(AddMenuHeadingAction({ heading: "" }));
    } else {
      sessionStorage.setItem("selectedMenu", menu);
      dispatch(AddMenuHeadingAction({ heading: menu }));
    }
    dispatch(setSelectedMenuPathAction(route));

    //MobileMenu: Automatically close the Mobile Dialog and Sidebar when a menu item is clicked
    if (isMobile) {
      setOpenMobileMenu(false);
      dispatch({ type: ActionTypes.CLOSE_MENU });
    }
  };
  const handleDrawerOpen = () => {
    dispatch({ type: ActionTypes.OPEN_MENU });
  };

  const handleDrawerClose = () => {
    dispatch({ type: ActionTypes.CLOSE_MENU });
  };

  const handleDrawerFix = () => {
    setHoverLock(true);
    fixedMenu
      ? dispatch({ type: ActionTypes.FIXED_MENU_CLOSE })
      : dispatch({ type: ActionTypes.FIXED_MENU_OPEN });
    setTimeout(() => setHoverLock(false), 300);
  };

  const handleAtsCollapse = () => {
    dispatch({ type: ActionTypes.ATS_COLLAPSE_MENU });
  };
  const handleLmsCollapse = () => {
    dispatch({ type: ActionTypes.LMS_COLLAPSE_MENU });
  };
  const handleAtsManageCollapse = () => {
    dispatch({ type: ActionTypes.ATS_COLLAPSE_SUB_MENU });
  };

  const handleAtsReportCollapse = () => {
    dispatch({ type: ActionTypes.ATS_REPORT_COLLAPSE_MENU });
  };
  const handleEmployeeCollapse = () => {
    dispatch({ type: ActionTypes.EMPLOYEE_COLLAPSE_MENU });
  };
  const handleFinanceCollapse = () => {
    dispatch({ type: ActionTypes.FINACNE_COLLAPSE_MENU });
  };

  const handleMyFinanceCollapse = () => {
    dispatch({ type: ActionTypes.MY_FINACNE_COLLAPSE_MENU });
  };
  const handleVisitorsCollapse = () => {
    dispatch({ type: ActionTypes.VISITORS_MANAGEMENT_COLLAPSE_MENU });
  };
  const handleCanteenCollapse = () => {
    dispatch({ type: ActionTypes.CANTEEN_MANAGEMENT_COLLAPSE_MENU });
  };
  const handleExpenseCollapse = () => {
    dispatch({ type: ActionTypes.EXPENSE_MANAGEMENT_COLLAPSE_MENU });
  };
  const handleSettingsCollapse = () => {
    dispatch({ type: ActionTypes.SETTINGS_COLLAPSE_MENU });
  };
  const ATSAccess = atsModuleData?.find((item) => item.module_name === "ATS");
  const leaveAccess = atsModuleData?.find(   // workspace level identifier
    (item) => item.module_name === "Leave"
  );
  const leaveUserAccess = atsModuleData?.find(   // user level identifier, but always check workspace level identifier first
    (item) => item.module_name === "LMS User"
  );
  const CoreHRAccess = atsModuleData?.find(
    (item) => item.module_name === "Core HR"
  );

  const myEmployeeAccess = atsModuleData?.find(
    (item) => item.module_name === "My Employee"
  );
  const settingsAccess = atsModuleData?.find(
    (item) => item.module_name === "Settings"
  );

  const atsDashboarAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Dashboard"
  );
  const atsHiringRequestAccess = atsModuleData?.find(
    (item) => item.module_name === "MPR"
  );
  const atsCandidateAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Candidate"
  );

  const atsJobPostAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Job Post"
  );

  const atsConfigureAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Configure"
  );

  const atsReportCandidateProgressAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Candidate Progress"
  );

  const atsReportRecruiterEfficiencyMetricsAccess = atsModuleData?.find(
    (item) => item.module_name === "ATS Recruiter Efficiency Metrics"
  );
  const payrollAccess = atsModuleData?.find(
    (item) => item.module_name === "Payroll"
  );
  const lmsExecutiveAccess = userData?.core_hr_user_type === "Employee" && atsModuleData?.some(
    (item) => item.module_name === "LMS Executive"
  );
  const FNFAccess = atsModuleData?.some(
    (item) => item.module_name === "FNF"
  );
  const CanteenAccess = atsModuleData?.some(
    (item) => item.module_name === "Canteen Management"
  );
  const ExternalUserCoreHr = atsModuleData?.some(
    (item) => item.module_name === "External User CoreHr"
  );
  const AuthorizationManagementAccess = atsModuleData?.find((item) => item.module_name === "Authorization Management");

  const payrollExecutiveAccess = checkPayrollAccess();
  const visitorsManagementAccess = userData?.workspace_visitor_management_flag && userData?.enable_visitor_management && userData?.f_country_code === "IND"
  const VMExecutiveAccess = atsModuleData?.find((item) => item.module_name === "VM Executive Access");
  const expenseManagementAccess = userData?.workspace_expense_flag && userData?.f_country_code === "IND";

  const sideBarData1 = [
    {
      label: "Home",
      icon: <DashboardIcon fontSize="small" />,
      route: "/home",
      show: true,
    },
    {
      label: "It's Me",
      icon: <BadgeIcon fontSize="small" />,
      route: "/employee",
      show: CoreHRAccess && !ExternalUserCoreHr,
    },
    // { label: "My Employee", icon: <PersonIcon fontSize='small' />, route: "/myemployee",show: myEmployeeAccess,state: "grid"  },
    // { label: "My Leave (Beta)", icon: <EditCalendarIcon fontSize='small' />, route: "/leave", show: leaveAccess},
  ];

  const sideBarData2 = [
    {
      label: "Quick Setup",
      icon: <AutoFixHighIcon fontSize="small" />,
      route: "/configure-setting",
      show:
        configurestatusData?.[0]?.onboarding_completed === false ? true : false,
      state: "Quick Setup",
    },
    {
      label: "General",
      icon: <BuildIcon fontSize="small" />,
      route: "/settings",
      show: CoreHRAccess,
    },
    {
      label: "Performance Management",
      icon: <AssessmentIcon fontSize="small" />,
      route: "/settings/performance-management",
      show: CoreHRAccess && (getDomain() === "cvtmeepl" || getDomain() === "adobemeepl"),
    },
    // { label: "Onboarding ", icon: <DepartureBoardIcon fontSize='small' />, route: "/onboarding-settings", show: CoreHRAccess, },
    {
      label: "Finance",
      icon: <SavingsIcon fontSize="small" />,
      route: "/finance-settings",
      show:
        payrollExecutiveAccess &&
        payrollAccess &&
        // ['cvtmeepl', "xpohrmeepl", "altiio", "adobemeepl", "kmkmeepl", "paycmeepl", "bpmeepl", "nirahameepl", "abmeepl", "uatkmmeepl","sogbimeepl"].includes(userData?.domain)
        userData?.f_country_code === "IND",
    },
    {
      label: "Roles & Access",
      icon: <AccessibilityIcon fontSize="small" />,
      route: "/role-access",
      show: false,
    },
    {
      label: "Expense Management",
      icon: <TuneIcon fontSize="small" />,
      route: "/expense-management/settings",
      show: expenseManagementAccess && (userData?.enable_expense_executive || userData?.core_hr_user_type === "Owner"),
    },
    {
      label: "Visitor Management",
      icon: <ManageAccountsIcon fontSize="small" />,
      route: "/visitors-management/settings",
      show: visitorsManagementAccess,
    },
    {
      label: "Canteen Management",
      icon: <FlatwareIcon fontSize="small" />,
      route: "/canteen-management/settings",
      show: CanteenAccess,
    },
    {
      label: "ATS",
      icon: <ContentPasteSearchIcon fontSize="small" />,
      route: "/ats/ats-settings/",
      show: atsConfigureAccess && userData?.enable_ats && userData?.enable_ats_user,
    },
    {
      label: "Subscription",
      icon: <PaymentIcon fontSize="small" />,
      route: "/subscribe",
      show: true,
    },
  ];

  const payrollOptions = [
    { label: "PayInsights", icon: <DashboardCustomizeIcon fontSize='small' />, route: "/payroll-dashboard", show: payrollExecutiveAccess, state: "grid" },
    // { label: "Employee Time", icon: <WorkHistoryIcon fontSize='small' />, route: "/employee-time", show: payrollExecutiveAccess, state: "grid" },
    { label: "PayConfig", icon: <WorkIcon fontSize='small' />, route: "/payrollconfig-employee", show: payrollExecutiveAccess, state: "grid" },
    { label: "PayEntry", icon: <TuneIcon fontSize='small' />, route: "/payroll-wage-entry", show: payrollExecutiveAccess, state: "grid" },
    { label: "PayRun", icon: <SummarizeIcon fontSize='small' />, route: "/payroll-management", show: payrollExecutiveAccess, state: "grid" },
    { label: "PayReports", icon: <RequestQuoteIcon fontSize='small' />, route: "/myemployee-reports", show: payrollExecutiveAccess, state: "grid" },
    { label: "PayECMS", icon: <PriceChangeIcon fontSize='small' />, route: "/payroll-payecms", show: FNFAccess, state: "grid" },
    { label: "Team Tax Approval", icon: <AdminPanelSettingsIcon fontSize='small' />, route: "/team-tax-declaration", show: payrollExecutiveAccess, state: "grid" },
  ]
  const atsOptions = [
    {
      label: "ATS Dashboard",
      icon: <DashboardIcon fontSize="small" />,
      route: "/ats/dashboard",
      show: atsDashboarAccess,
    },
    {
      label: "Tasks",
      icon: <AssignmentIcon fontSize="small" />,
      route: "/ats/tasks/",
      show: true,
    },
    {
      label: "Hiring Request",
      icon: <RequestQuoteIcon fontSize='small' />,
      route: "/ats/hiring-requests",
      show: atsHiringRequestAccess,
    },
    {
      label: "Job Dashboard",
      icon: <WorkIcon fontSize="small" />,
      route: "/ats/manage-job",
      show: atsJobPostAccess,
    },
    {
      label: "Candidate",
      icon: <PersonIcon fontSize="small" />,
      route: "/ats/manage-candidate",
      show: atsCandidateAccess,
    },
  ];
  const atsSubMenu = [
    {
      label: "Add Users",
      icon: <EngineeringIcon fontSize="small" />,
      route: "/ats/manage-user",
      show: true,
      tooltip: "Manage Users",
    },
    {
      label: "Add Client",
      icon: <AccountBalanceIcon fontSize="small" />,
      route: "/ats/manage-company",
      show: !isGroupOrgFlowTrue,
      tooltip: "Manage Clients",
    },
    {
      label: "Add Group Organisation",
      icon: <AccountBalanceIcon fontSize="small" />,
      route: "/ats/manage-group-company",
      show: isGroupOrgFlowTrue,
      tooltip: "Manage Group Organisation",
    },
    {
      label: "Add Hiring Partner",
      icon: <GroupWorkIcon fontSize="small" />,
      route: "/ats/manage-consultancy",
      show: true,
      tooltip: "Manage Hiring partner",
    },
  ];
  const atsReportMenu = [
    {
      label: "Dashboard",
      icon: <DashboardIcon fontSize="small" />,
      route: "/ats/manage-reports/",
      show: atsReportCandidateProgressAccess ? true : false,
      tooltip: "Reports Dashboard",
    },
    {
      label: "Operational Reports",
      icon: <DescriptionIcon fontSize="small" />,
      route: "/ats/reports/",
      show: atsReportRecruiterEfficiencyMetricsAccess ? true : false,
      tooltip: "Quality Reports",
    },
    {
      label: "Revenue",
      icon: <AttachMoneyIcon fontSize="small" />,
      route: "/ats/revenue/",
      show: atsReportCandidateProgressAccess ? true : false,
      tooltip: "Revenue",
    },
  ];
 const  sideBarData3 =[
  { label: "Achievement Orchestrator", icon: <EmojiEventsIcon fontSize='small' />, route: "/performance-management",show:true }
 ]
  //LMS Section
  const lmsSubMenu = [
    {
      label: "Dashboard",
      icon: <DashboardIcon fontSize="small" />,
      route: "/lms/manage-dashboard",
      show: leaveUserAccess && !ExternalUserCoreHr,
    },
    {
      label: "My Timesheet",
      icon: <PendingActionsIcon fontSize="small" />,
      route: "/lms/manage-timesheet",
      show: leaveUserAccess && !ExternalUserCoreHr,
    },
    {
      label: "Team",
      icon: <Diversity3Icon fontSize="small" />,
      route: "/lms/manage-team",
      show:  isAdminOwner() || lmsExecutiveAccess,
    },
    {
      label: "Team Time",
      icon: <WorkHistoryIcon fontSize="small" />,
      route: "/lms/team-time",
      show: false,  // no needed this sub-module
    },
    {
      label: "Time Bulk Upload",
      icon: <CloudUploadIcon fontSize="small" />,
      route: "/time-bulk-upload",
      show: isAdminOwner(),
    },
    {
      label: "Holidays",
      icon: <EventNoteIcon fontSize="small" />,
      route: "/holidays",
      show: leaveUserAccess,
    },
  ];
  // My finance section  
  const myFinanceSubMenu = [
    {
      label: "Tax Declaration",
      icon: <RuleIcon fontSize="small" />,
      route: "/tax-declaration",
      show: payrollAccess,
      state: "grid",
    },
    {
      label: "Reports ",
      icon: <RequestQuoteIcon fontSize="small" />,
      route: "/employee-report",
      show: payrollAccess,
      state: "grid",
    },
  ];
  // visitors management
  const visitorsManagementSubMenu = [
    {
      label: "Dashboard ",
      icon: <DashboardIcon fontSize="small" />,
      route: "/visitors-dashboard",
      show: VMExecutiveAccess,
      state: "grid",
    },
    {
      label: "Pre-registration",
      icon: <AssignmentIcon fontSize="small" />,
      route: "/visitors-pre-registration",
      show: visitorsManagementAccess,
      state: "grid",
    },
    {
      label: "Report",
      icon: <AssignmentIndIcon fontSize="small" />,
      route: "/visitors-record",
      show: VMExecutiveAccess,
      state: "grid",
    },
    {
      label: "Visitor Entry",
      icon: <PersonIcon fontSize="small" />,
      route: "/visitors-management-region",
      show: VMExecutiveAccess,
      state: "grid",
    },
  ];
  // canteen management
  const canteenManagementSubMenu = [
    {
      label: "Token Config",
      icon: <ConfirmationNumberIcon fontSize="small" />,
      route: "/canteen-management-tokenconfig",
      show: CanteenAccess,
      state: "grid",
    },
    {
      label: "Canteen Entry",
      icon: <StorefrontIcon fontSize="small" />,
      route: "/canteen-management-region",
      show: CanteenAccess,
      state: "grid",
    }
  ];
  // expense management
  const expenseManagementSubMenu = [
    {
      label: "My Expenses",
      icon: <AccountBalanceWalletIcon fontSize="small" />,
      route: "/expense-management/my-expenses",
      show: expenseManagementAccess && !ExternalUserCoreHr,
      state: "grid",
    },
    {
      label: "Team Expenses",
      icon: <SupervisorAccountIcon fontSize="small" />,
      route: "/expense-management/team-expenses",
      show: expenseManagementAccess && (userData?.enable_expense_executive || userData?.core_hr_user_type === "Owner"),
      state: "grid",
    },
  ];
  const employeeOptions = [
    {
      label: "Employee",
      icon: <AssignmentIndIcon fontSize="small" />,
      route: "/myemployee",
      show: myEmployeeAccess,
      state: "grid",
    },
    // {
    //   label: "Employee Access Control",
    //   icon: <ManageAccountsIcon fontSize="small" />,
    //   route: "/authorization-management",
    //   show: myEmployeeAccess,
    //   state: "grid",
    // },
    { 
      label: "Employee Bulk Upload",
      icon: <CloudUploadIcon fontSize="small" />,
      route: "/employee-bulk-upload",
      show: myEmployeeAccess && !ExternalUserCoreHr,
      state: "grid",
    },
    {
      label: "Asset Management",
      icon: <BadgeIcon fontSize="small" />,
      route: "/myemployee-assets-management",
      show: FNFAccess,
      state: "grid",
    },
  ];

  const sideFNFData = [
    { label: "Exit Management", icon: <ReduceCapacityIcon fontSize='small' />, route: "/exit-management", show: true }
  ]
  const sideAuthorizationData = [
    { label: "Authorization Management", icon: <AdminPanelSettingsIcon fontSize='small' />, route: "/authorization-management", show: true }
  ]
  return (
    <>
      <Box
        sx={{ display: "flex" }}
        role="presentation"
        className={`${isMobile && "mobileview"}`}
      >
        <Popup
          maxWidth="xs"
          openPopup={show}
          setOpenPopup={setShow}
          close={false}
        >
          <PlanExpired
            openPopup={show}
            setOpenPopup={setShow}
            userInfoData={userInfoData}
            popupContent={popupContent}
            setPopupContent={setPopupContent}
            planExpired={planExpired}
            planRemain={planRemain}
          />
        </Popup>
        <CssBaseline />
        <PowerUserWarningPopup />
        <ProposeCandidateConfirmation />
        {
          <MobileMenu
            settingsAccess={settingsAccess}
            open={openMobileMenu}
            close={setOpenMobileMenu}
            sideBarData1={sideBarData1}
            sideBarData2={sideBarData2}
            handleMenuClick={handleMenuClick}
            selectedMenu={selectedMenu}
            isMobile={isMobile}
            theme={theme}
            userData={userData}
            financeCollapse={financeCollapse}
            setFinanceCollapse={handleFinanceCollapse}
            access={access}
            payrollOptions={payrollOptions}
            atsCollapse={atsCollapse}
            setAtsCollapse={handleAtsCollapse}
            atsOptions={atsOptions}
            atsSubMenu={atsSubMenu}
            atsManageCollapse={atsManageCollapse}
            setAtsManageCollapse={handleAtsManageCollapse}
            atsReportCollapse={atsReportCollapse}
            setReportCollapse={handleAtsReportCollapse}
            atsReportMenu={atsReportMenu}
            lmsCollapse={lmsCollapse}
            setLmsCollapse={handleLmsCollapse}
            lmsSubMenu={lmsSubMenu}
            EmployeeCollapse={EmployeeCollapse}
            setEmployeeCollapse={handleEmployeeCollapse}
            employeeOptions={employeeOptions}
            myfinanceCollapse={myfinanceCollapse}
            handleMyFinanceCollapse={handleMyFinanceCollapse}
            collapse={settingCollapse}
            setCollapse={handleSettingsCollapse}
            myFinanceSubMenu={myFinanceSubMenu}
            visitorsCollapse={visitorsCollapse}
            handleVisitorsCollapse={handleVisitorsCollapse}
            visitorsManagementSubMenu={visitorsManagementSubMenu}
            expenseCollapse={expenseCollapse}
            handleExpenseCollapse={handleExpenseCollapse}
            expenseManagementSubMenu={expenseManagementSubMenu}
            sideFNFData={sideFNFData}
            canteenCollapse={canteenCollapse}
            handleCanteenCollapse={handleCanteenCollapse}
            canteenManagementSubMenu={canteenManagementSubMenu}
            sideAuthorizationData={sideAuthorizationData}
          />
        }
        {!isMobile && (
          <Drawer
            PaperProps={{
              sx: {
                borderRight: "none",
                mr: -4,
                backgroundColor:
                  theme.palette.mode === "dark"
                    ? theme?.palette?.dark?.dark1
                    : theme?.palette?.root?.main,
              },
            }}
            variant="permanent"
            open={open}
            className="menulanding"
            fixMenuVal={fixedMenu}
            onMouseEnter={() => !hoverLock && !fixedMenu && !isMobile && handleDrawerOpen()}
            onMouseLeave={() => !hoverLock && !fixedMenu && !isMobile && handleDrawerClose()}
          >
            <DrawerHeader
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "12px 12px",
              }}
            >
              {/* Logo Container */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "140px", // Set your desired width
                  height: "40px",
                }}
              >
                <FullLogo
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>

              {/* Icon Button */}
              <IconButton
                onClick={handleDrawerFix}
                sx={{ padding: 0, margin: 0 }}
              >
                {open ? (
                  <Checkbox
                    color="secondary"
                    {...label}
                    icon={<CircleOutlinedIcon />}
                    checkedIcon={<AdjustIcon />}
                    checked={fixedMenu}
                  />
                ) : !isMobile ? (
                  <Box sx={{ height: "50px", width: "40px" }}>
                    <Logo />
                  </Box>
                ) : (
                  <MenuIcon />
                )}
              </IconButton>
            </DrawerHeader>

            {userData?.domain === "meepl" ? (
              <AdminMenuBar
                handleMenuClick={handleMenuClick}
                theme={theme}
                selectedMenu={selectedMenu}
                open={open}
                isMobile={isMobile}
              />
            ) : (
              <List
                sx={{
                  padding: "0px 3px 0px 3px",
                  overflowY: open ? "auto" : "hidden",
                  maxHeight: settingCollapse
                    ? (configurestatusData?.[0]?.onboarding_completed === false ? "30%" : "calc(100vh - 335px)")
                    : "calc(100vh - 128px)"
                }}
              >
                {sideBarData1.map((res, id) => {
                  return (
                    <Link
                      key={id}
                      to={{ pathname: res?.route, state: res?.state }}
                    >
                      {res?.show && (
                        <ListItem
                          key={id}
                          disablePadding
                          sx={{
                            display: "block",
                            fontSize: "12px",
                            marginLeft: 0,
                          }}
                          onClick={(e) =>
                            handleMenuClick(res?.label, res?.route)
                          }
                        >
                          <ListItemButton
                            selected={selectedMenu === res?.label}
                            key={id}
                            sx={{
                              "&.Mui-selected": {
                                backgroundColor:
                                  theme?.palette?.primary?.main + "20",
                              },
                              borderRadius: "8px",
                              fontWeight: 600,
                              minHeight: 44,
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: open ? "flex-start" : "center",
                              gap: open ? 2 : 0, // Use gap instead of margin-right
                              padding: open ? "8px 12px" : "8px", // Simplified padding
                              transition: "all 0.3s ease",
                            }}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: 0,
                                width: open ? "auto" : "24px", // Fixed width for icon when closed
                                height: "24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.3s ease",
                                "& svg": {
                                  fontSize: "20px",
                                  transition: "all 0.3s ease",
                                },
                              }}
                            >
                              <span
                                style={{
                                  color:
                                    selectedMenu === res?.label
                                      ? theme?.palette?.primary?.main
                                      : theme.palette.mode === "dark"
                                      ? theme.palette.text.primary
                                      : theme.palette.text.secondary,
                                  transition: "color 0.3s ease",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {res?.icon}
                              </span>
                            </ListItemIcon>

                            {open && (
                              <ListItemText
                                primaryTypographyProps={{
                                  variant: "body2",
                                  fontWeight:
                                    selectedMenu === res?.label ? 600 : 550,
                                  fontSize: "0.8rem",
                                  color:
                                    selectedMenu === res?.label
                                      ? "primary"
                                      : grey[600],
                                }}
                                primary={res?.label}
                                sx={{
                                  flex: 1, // Take remaining space
                                  margin: 0, // Remove default margins
                                  pl: "3px"
                                }}
                              />
                            )}
                          </ListItemButton>
                        </ListItem>
                      )}
                    </Link>
                  );
                })}
                
                {
                 (getDomain() === "cvtmeepl" || getDomain() === "adobemeepl") && !ExternalUserCoreHr && ( sideBarData3.map((res, id) => {
                      return (
                        <Link key={id} to={{ pathname: res?.route, state: res?.state}}>
                        {res?.show && 
                          <ListItem
                            key={id}
                            disablePadding
                            sx={{ display: 'block', fontSize: "12px", marginLeft: 0 }}
                            onClick={(e) => (handleMenuClick(res?.label, res?.route))}
                          >
                            <ListItemButton
                              selected={selectedMenu === res?.label}
                              key={id}
                              sx={{
                                "&.Mui-selected": {
                                  backgroundColor:
                                    theme?.palette?.primary?.main + "20",
                                },
                                borderRadius: "8px",
                                fontWeight: 600,
                                minHeight: 44,
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: open ? "flex-start" : "center",
                                gap: open ? 2 : 0, // Use gap instead of margin-right
                                padding: open ? "8px 12px" : "8px", // Simplified padding
                                transition: "all 0.3s ease",
                              }}
                            >
                              <ListItemIcon
                                key={id}
                                sx={{
                                minWidth: 0,
                                width: open ? "auto" : "24px", // Fixed width for icon when closed
                                height: "24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "all 0.3s ease",
                                "& svg": {
                                  fontSize: "20px",
                                  transition: "all 0.3s ease",
                                },
                              }}
                              >
                                <span
                                style={{
                                  color:
                                    selectedMenu === res?.label
                                      ? theme?.palette?.primary?.main
                                      : theme.palette.mode === "dark"
                                      ? theme.palette.text.primary
                                      : theme.palette.text.secondary,
                                  transition: "color 0.3s ease",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {res?.icon}
                              </span>
                              </ListItemIcon>
                              {open && (
                              <ListItemText
                                primaryTypographyProps={{
                                  variant: "body2",
                                  fontWeight:
                                    selectedMenu === res?.label ? 600 : 550,
                                  fontSize: "0.8rem",
                                  color:
                                    selectedMenu === res?.label
                                      ? "primary"
                                      : grey[600],
                                }}
                                primary={res?.label}
                                sx={{
                                  flex: 1, // Take remaining space
                                  margin: 0, // Remove default margins
                                  pl: "3px"
                                }}
                              />
                            )}
                            </ListItemButton>
                          </ListItem>
                        }
                        </Link>
                      )
                    }))
                  }

                {leaveAccess && (leaveUserAccess || lmsExecutiveAccess) && userData?.f_country_code === "IND" && (
                  <LmsMenu
                    lmsCollapse={lmsCollapse}
                    setLmsCollapse={handleLmsCollapse}
                    open={open}
                    lmsSubMenu={lmsSubMenu}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                  />
                )}

                {payrollAccess && !ExternalUserCoreHr && userData?.f_country_code === "IND" && (
                  <MyFinanceMenu
                    myfinanceCollapse={myfinanceCollapse}
                    setMYFinanceCollapse={handleMyFinanceCollapse}
                    open={open}
                    myFinanceSubMenu={myFinanceSubMenu}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                  />
                )}

                {myEmployeeAccess && (
                  <EmployeeMenu
                    EmployeeCollapse={EmployeeCollapse}
                    setEmployeeCollapse={handleEmployeeCollapse}
                    open={open}
                    employeeOptions={employeeOptions}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                  />
                )}
                {/* ECMS Exit Clearance Man. System */}
                {AuthorizationManagementAccess && (
                  <AuthorizationMenu
                    open={open}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                    sideAuthorizationData={sideAuthorizationData}
                  />
                )}

                {/* Payroll Finance Menu */}
                {payrollExecutiveAccess && (
                  <FinanceMenu
                    financeCollapse={financeCollapse}
                    setFinanceCollapse={handleFinanceCollapse}
                    open={open}
                    payrollOptions={payrollOptions}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                  />
                )}
                {/* expense management */}
                {expenseManagementAccess && !(ExternalUserCoreHr && !userData?.enable_expense_executive) && (
                  <ExpenseManagementMenu
                    expenseCollapse={expenseCollapse}
                    handleExpenseCollapse={handleExpenseCollapse}
                    open={open}
                    expenseManagementSubMenu={expenseManagementSubMenu}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                  />
                )}
                   {/* Visitor Management */}
                {visitorsManagementAccess && (
                  <VisitorsManagementMenu
                    visitorsCollapse={visitorsCollapse}
                    handleVisitorsCollapse={handleVisitorsCollapse}
                    open={open}
                    visitorsManagementSubMenu={visitorsManagementSubMenu}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                  />
                )}
                   {/* Canteen Management */}
                {CanteenAccess && isAdminOwner() && (
                  <CanteenManagementMenu
                    canteenCollapse={canteenCollapse}
                    handleCanteenCollapse={handleCanteenCollapse}
                    open={open}
                    canteenManagementSubMenu={canteenManagementSubMenu}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                  />
                )}
                {/* ECMS Exit Clearance Man. System */}
                {FNFAccess && !ExternalUserCoreHr && userData?.f_country_code === "IND" && (
                  <ECMSMenu
                    open={open}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    isMobile={isMobile}
                    theme={theme}
                    sideFNFData={sideFNFData}
                  />
                )}
                {/* ATS Menu */}
                {atsDashboarAccess && ATSAccess && userData?.enable_ats && userData?.enable_ats_user && (
                  <AtsMenu
                    userInfoData={userInfoData}
                    atsCollapse={atsCollapse}
                    setAtsCollapse={handleAtsCollapse}
                    open={open}
                    sideBarData={atsOptions}
                    userData={userData}
                    selectedMenu={selectedMenu}
                    handleMenuClick={handleMenuClick}
                    theme={theme}
                    isMobile={isMobile}
                    atsSubMenu={atsSubMenu}
                    setAtsManageCollapse={handleAtsManageCollapse}
                    atsManageCollapse={atsManageCollapse}
                    atsReportCollapse={atsReportCollapse}
                    setReportCollapse={handleAtsReportCollapse}
                    atsReportMenu={atsReportMenu}
                  />
                )}
          
              </List>
            )}

            {/* Settings Menu */}
            {settingsAccess && (
              <SettingsMenu
                atsCollapse={atsCollapse}
                setAtsCollapse={handleAtsCollapse}
                collapse={settingCollapse}
                setCollapse={handleSettingsCollapse}
                open={open}
                sideBarData2={sideBarData2}
                userData={userData}
                selectedMenu={selectedMenu}
                handleMenuClick={handleMenuClick}
                theme={theme}
              />
            )}
            <List
              sx={{
                position: "fixed",
                bottom: 0,
                width: "inherit",
                padding: "0px 0px 15px 0px",
              }}
            >
              {settingsAccess && (
                <>
                  {/* Main Settings Button */}
                  <ListItem
                    disablePadding
                    sx={{ display: "block", fontSize: "12px" }}
                  >
                    <ListItemButton
                      sx={{
                        borderRadius: "8px",
                        fontWeight: 600,
                        minHeight: 44,
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: open ? "flex-start" : "center",
                        gap: open ? 2 : 0,
                        padding: open ? "8px 12px" : "8px",
                        transition: "all 0.3s ease",
                      }}
                      onClick={() => handleSettingsCollapse()}
                      disableRipple
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "24px",
                          height: "24px",
                        }}
                      >
                        <span
                          style={{
                            color:
                              selectedMenu === "Settings"
                                ? theme?.palette?.primary?.main
                                : theme.palette.mode === "dark"
                                ? theme.palette.text.primary
                                : theme.palette.text.secondary,
                            transition: "color 0.3s ease",
                          }}
                        >
                          <SettingsSuggestIcon />
                        </span>
                      </Box>
                      {open && (
                        <ListItemText
                          primaryTypographyProps={{
                            variant: "body2",
                            fontWeight: selectedMenu === "Settings" ? 600 : 550,
                            fontSize: "0.8rem",
                            color:
                              selectedMenu === "Settings"
                                ? "primary"
                                : grey[600],
                          }}
                          primary="Settings"
                          sx={{ margin: 0 }}
                        />
                      )}
                      {open && (settingCollapse ? <ExpandMore /> : <ExpandLess />)}
                    </ListItemButton>
                  </ListItem>
                  
                  {/* Settings Submenu - only show when collapsed AND drawer is open */}
                  {settingCollapse && open && (
                    <SettingsMenu
                      collapse={settingCollapse}
                      setCollapse={handleSettingsCollapse}
                      open={open}
                      sideBarData2={sideBarData2}
                      userData={userData}
                      selectedMenu={selectedMenu}
                      handleMenuClick={handleMenuClick}
                      theme={theme}
                    />
                  )}
                </>
              )}
            </List>

          </Drawer>
        )}
        <Box component="main" sx={{ flexGrow: 1, width: isMobile ? "100%" : !open ? "calc(100vw - 65px)" : "calc(100vw - 245px)" }}>
          <AppBar
            isMobile={isMobile}
            theme={theme.palette.mode}
            setOpenMobileMenu={setOpenMobileMenu}
          />
          <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          {children}
          <Footer />
        </Box>
      </Box>
    </>
  );
}
